// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM10.9996 9.04019L7.61829 7.13818L6.63776 8.88133L8.45877 9.90565L6.59961 11.3L7.79961 12.9L10.9996 10.5L10.9996 9.04019ZM15.5404 9.90565L17.3614 8.88133L16.3809 7.13818L12.9996 9.04019L12.9996 10.5L16.1996 12.9L17.3996 11.3L15.5404 9.90565ZM9.40036 14.4993L8.89964 13.6337L7.16843 14.6351L7.66915 15.5007C8.53217 16.9926 10.1477 18 11.9996 18C13.8516 18 15.4671 16.9926 16.3301 15.5007L16.8308 14.6351L15.0996 13.6337L14.5989 14.4993C14.0787 15.3986 13.1088 16 11.9996 16C10.8905 16 9.92059 15.3986 9.40036 14.4993Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-excited-1-filled')
export default class Excited1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'excited-1-filled',
    }
  }
}
